<template>
  <div id="messaging">
    <div
      v-if="request.messages.length > 0"
      id="message-list"
      :class="{submitting: submitting}"
    >
      <div
        ref="message-list__scroller"
        class="message-list__scroller"
      >
        <message-view
          v-for="message in request.messages"
          :key="message.id"
          :message="message"
        />
      </div>
    </div>
    <p v-else>
      Start a conversation?
    </p>

    <div class="new-message">
      <div class="attached-files">
        <span
          v-for="(attachment, key) in attachments"
          :key="key"
          class="attachment text-success"
        >
          {{ attachment.name }}
          <button
            :disabled="submitting"
            class="btn btn-link btn-xs"
            @click="removeAttachment(key)"
          >
            <font-awesome-icon
              prefix="fal"
              icon="times"
            />
          </button>
        </span>
      </div>
      <new-message-view
        v-if="!request.is_complete"
        :disabled="submitting || request.is_complete"
        @attachFile="attachFile"
        @submitted="newMessage"
      />
      <div v-else>
        <font-awesome-icon icon="check" /> Document request complete
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import DocumentRequestModel from '../../../models/documentRequest';
import MessageView from './messaging/message.vue';
import NewMessageView from './messaging/newMessage.vue';

export default {
  components: {
    NewMessageView,
    MessageView,
  },

  props: {
    request: {
      type: DocumentRequestModel,
      required: true,
    },
  },

  data() {
    return {
      attachments: [],
      submitting: false,
    };
  },

  mounted() {
    this.scrollMessagesToBottom();
  },

  updated() {
    this.scrollMessagesToBottom();
  },

  methods: {
    newMessage(message) {
      const formData = new FormData();
      this.submitting = true;
      formData.append('message', message);

      _.forEach(this.attachments, (file) => {
        formData.append('files[]', file);
      });

      this.ApiService.documentRequestReply(this.request.deal_id, this.request.id, formData)
        .then((request) => {
          this.attachments = [];
          this.submitting = false;
          this.$emit('updateRequest', request);
        })
        .catch((error) => {
          this.alertBox({ type: 'error', message: error });
          this.submitting = false;
        });
    },

    removeAttachment(pos) {
      this.attachments.splice(pos, 1);
    },

    attachFile() {
      this.alertBox({
        dataFields: [
          { type: 'file', name: 'attachments', validation: 'required' },
          // {type: 'span', name: '', value: 'We cannot accept bank details or credit card details online'}
        ],
      }).then((data) => {
        this.attachments = this.attachments.concat(data.attachments);
      }).catch(() => {
      });
    },

    scrollMessagesToBottom() {
      const scroll = this.$refs['message-list__scroller'];
      if (scroll) {
        scroll.scrollTop = scroll.scrollHeight;
      }
    },
  },
};
</script>

<style lang="scss">
@import './resources/assets/sass/variables';
#messaging {
  .messaging__header {
      border-bottom: 1px solid grey;
  }
  #message-list {
    .message-list__scroller {
      overflow: auto;
      max-height: 60vh;
      padding: 0 5px 5px 0;
    }
    &.submitting {
      position: relative;
      &:after {
        content: '';
        color: $white;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        text-align: center;
        width: 100%;
        height: 100%;
        z-index: 999;
        background-color: rgba(0,0,0,0.3);
      }
    }
  }
  .new-message {
    margin-top: 1em;
    .input-group {
      .input-group-addon {
        padding: 0;
        border-radius: 4px 0 0 4px;
        button {
          padding: 5px 12px;
        }
      }
      input.form-control {
        border-radius: 0 4px 4px 0;
      }
    }
  }
}
</style>
